module.exports = __webpack_public_path__ + "static/media/5.b9ce70cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/5.png
// module id = 622
// module chunks = 0